(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/shared/prolong-dialogs.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/shared/prolong-dialogs.js');
"use strict";


const showProlongedGeoDialog = _ref => {
  let {
    charity,
    wagerId
  } = _ref;
  const actions = [];
  let title;
  let messageText;
  if ((charity === null || charity === void 0 ? void 0 : charity.charityId) > 0 && charity !== null && charity !== void 0 && charity.name) {
    title = 'Din lyckoplats är betald';
    messageText = "".concat(charity.name, " tackar f\xF6r ditt fortsatta bidrag.");
    actions.push({
      title: 'Okej'
    });
  } else {
    title = 'Välj en organisation att stötta';
    messageText = 'Din lyckoplats är betald. Men ta chansen att stötta en organisation med 10% av insatsen. Det kostar inget extra, påverkar varken dina vinstchanser eller hur mycket du kan vinna.';
    actions.push({
      title: 'Jag avstår'
    });
    actions.push({
      title: 'Välj',
      callback: (_e, _forms, dialog) => {
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('lyckoplatsenHome'), "/relaterat/").concat(wagerId, "/-1"));
        dialog.close();
      }
    });
  }
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'thumbs-up',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title,
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: messageText,
      align: svs.components.dialog.message.align.CENTER
    }],
    actions
  }));
};
const showAlreadyProlongedDialogAsync = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'information',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title: 'Du har redan förlängt detta spel',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Är du säker på att du vill förlänga detta spel? Tänk på att det kan bli en dubblett.',
      align: svs.components.dialog.message.align.CENTER
    }],
    actions: [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: () => {
        resolve(false);
        dialog.close();
      }
    }, {
      type: svs.components.dialog.button.PRIMARY,
      title: 'Förläng',
      callback: () => {
        resolve(true);
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
setGlobal('svs.tur.lyckoplatsen.shared', {
  showProlongedGeoDialog,
  showAlreadyProlongedDialogAsync
});

 })(window);